const WRITE_HEAVY_PREFIXES = [
  "/checkout",
  "/doctor",
  "/tx-plans",
  "/ortho-center",
  "/recall-center",
  "/expenses",
  "/settings/appointments",
  "/settings/chairs",
  "/settings/services",
  "/settings/team",
  "/settings/permissions",
  "/settings/email-templates",
  "/settings/reminders",
  "/settings/recall",
  "/settings/qr-codes",
  "/settings/methods",
  "/settings/insurance",
  "/settings/ortho",
  "/settings/clinic",
];

const FEATURE_PATHS = [
  { prefix: "/ortho-center", flag: "ortho_module" },
  { prefix: "/settings/ortho", flag: "ortho_module" },
  { prefix: "/tx-plans", flag: "tx_plan_center" },
  { prefix: "/reports", flags: ["reports", "clinic_health_calculator"] },
  { prefix: "/medical-history", flag: "medical_history" },
  { prefix: "/expenses", flag: "expenses" },
];

export const TENANT_FEATURE_LABELS = {
  reports: "Reports",
  tx_plan_center: "Tx Plan Center",
  tx_plan_charting: "Tx Plan Charting",
  ortho_module: "Ortho Module",
  medical_history: "Medical History",
  clinic_health_calculator: "Clinic Health Calculator",
  production_credit: "Production Credit",
  commission_engine: "Commission Engine",
  expenses: "Expenses",
};

// PLAN_LABELS keys mirror tenant_feature_required_plan() return values.
// 'solo_only' means a feature is intentionally restricted to the Solo plan
// (e.g. clinic_health_calculator — Clinic+ gets a richer Reports surface
// instead). We display "Solo" for that tier; the gating semantics live in
// the database, not the label.
export const PLAN_LABELS = {
  solo: "Solo",
  solo_only: "Solo",
  clinic: "Clinic",
  enterprise: "Enterprise",
};

export function isTenantWriteBlocked(access, pathname) {
  if (access?.mode !== "read_only") return false;
  const path = pathname || "/";
  return WRITE_HEAVY_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function getRequiredFeatureForPath(pathname) {
  return getRequiredFeaturesForPath(pathname)[0] || null;
}

export function getRequiredFeaturesForPath(pathname) {
  const path = pathname || "/";
  const match = FEATURE_PATHS.find(({ prefix }) => path === prefix || path.startsWith(`${prefix}/`));
  if (!match) return [];
  return Array.isArray(match.flags) ? match.flags : [match.flag].filter(Boolean);
}

export function isTenantFeatureBlocked(access, pathname) {
  const requiredFeatures = getRequiredFeaturesForPath(pathname);
  if (requiredFeatures.length === 0) return false;
  return !requiredFeatures.some((feature) => isTenantFeatureEnabled(access, feature));
}

export function isTenantFeatureEnabled(access, featureKey) {
  if (!featureKey) return true;
  const features = access?.features || {};
  return features[featureKey] === true;
}

export function formatTenantFeature(featureKey) {
  return TENANT_FEATURE_LABELS[featureKey] || String(featureKey || "this module")
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function requiredPlanForFeature(access, featureKey) {
  if (!featureKey) return null;
  return access?.required_plan?.[featureKey] || "clinic";
}

export function formatTenantPlan(plan) {
  return PLAN_LABELS[String(plan || "").toLowerCase()] || "Clinic";
}
